"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      width: '50%'
    },
    text: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      paddingLeft: theme.spacing(1)
    },
    label: (0, _extends2.default)({}, theme.typography.body1, {
      marginBottom: theme.spacing(1),
      fontWeight: 300,
      fontSize: 24,
      color: theme.palette.common.black
    }),
    links: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  };
}, {
  name: 'SxWebMainNavigationItemPopoverNest'
});

function MainNavigationItemPopoverNest(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      href = _ref.href,
      image = _ref.image,
      ImageComponent = _ref.ImageComponent,
      label = _ref.label,
      onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "href", "image", "ImageComponent", "label", "onClick"]);
  var classes = useStyles({
    classes: pClasses
  });
  return label && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, ImageComponent && /*#__PURE__*/_react.default.createElement(ImageComponent, (0, _extends2.default)({}, rest, {
    src: image,
    alt: label
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.text
  }, href ? /*#__PURE__*/_react.default.createElement(_Link.default, {
    to: href,
    className: classes.label,
    onClick: onClick
  }, label) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    to: href,
    className: classes.label,
    onClick: onClick
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.links
  }, children)));
}

process.env.NODE_ENV !== "production" ? MainNavigationItemPopoverNest.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    label: _propTypes.default.string,
    links: _propTypes.default.string,
    root: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  href: _propTypes.default.string,
  image: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string)), _propTypes.default.string]),
  ImageComponent: _propTypes.default.elementType.isRequired,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func
} : void 0;
MainNavigationItemPopoverNest.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  href: undefined,
  image: undefined,
  label: undefined,
  onClick: undefined
};
var _default = MainNavigationItemPopoverNest;
exports.default = _default;